import { createStore } from 'vuex'
import basic from "@/store/modules/basic";
import access from '@/store/modules/access.mjs'

const store = createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    basic: basic,
    access,
  }
})



export default store
